import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import utils from '../../utils/utilities.js';
import FormGroup from './FormGroup.jsx';

class RadioGroup extends Component {

    static propTypes = {
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]).isRequired,
        onChange: PropTypes.func.isRequired,
        options: PropTypes.array.isRequired,
        classNames: PropTypes.string,
        label: PropTypes.any,
        hasError: PropTypes.any,
        disabled: PropTypes.bool,
        required: PropTypes.bool,
        fieldId: PropTypes.string
    }

    static defaultProps = {
        label: null,
        hasError: false,
        disabled: false,
        required: false,
        classNames: "",
        fieldId: "radioGroup" + utils.generateRandomHash()
    }
    
    render() {
        const radioOptions = this.props.options.map((option, index) =>
            (<div key={this.props.fieldId + option.value}>
                <div className="option-item">
                    <input
                        type="radio"
                        name={this.props.fieldId}
                        value={option.value}
                        id={this.props.fieldId + index}
                        checked={this.props.value === option.value}
                        disabled={!!option.disabled || this.props.disabled}
                        onChange={this.props.onChange} />
                    <label htmlFor={this.props.fieldId + index} title={typeof(option.label) !== 'object' ? option.label : this.props.intl.formatMessage({id: option.label.props.id}) }>{option.label}</label>
                </div>
                {this.props.value === option.value && <div className="option-content">{option.content}</div>}
            </div>))

        return (
            <FormGroup {...this.props} fieldId={this.props.fieldId} classNames={this.props.classNames + " radio-group"}>
                {radioOptions}
            </FormGroup>
        )
    }
}

export default injectIntl(RadioGroup);


// WEBPACK FOOTER //
// ./src/scripts/reusable/Form/RadioGroup.jsx